import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';

import Select from '../../../shared/Select';
import Input from '../../../shared/Input';

import { caseConstants } from '../../../../constants';

const HardwareList = ({
  hardwareList = [],
  products = [],
  onAdd,
  onRemove,
  onAmountChange,
  onCategoryChange,
  onChange,
  title,
  procedureFlow
}) => {
  const theme = useTheme();

  const filteredProducts = products.map((item) => `${item.sku} — ${item.description}`);

  const hardwareCategories = procedureFlow === caseConstants.procedureFlows.ACL ? ['Allograft', 'Procedure Pack'] :caseConstants.hardwareCategories;

  const [addMode, toggleAddMode] = useState(false);
  const [newHardware, setNewHardware] = useState(filteredProducts[0]);
  const [amount, setAmount] = useState(1);
  const [category, setCategory] = useState(hardwareCategories[0]);
  const [hasError, setHasError] = useState(false);

  const handleAdd = () => {
    if (!newHardware || !category || !amount) {
      setHasError(true);
      return;
    }

    const id = Math.random();
    const hardware = { id, product: newHardware, amount, category };

    onAdd(hardware);
    setAmount(1);
    setCategory('');
    toggleAddMode(false);
    setHasError(false);
  };

  return (
    <div className="hardware-list-container">
      <div className="hardware-list-header">
        <div className="secondary uppercase font-size-sm">{title}</div>
        <div className="font-size-sm pointer" style={{ color: theme.palette.primary.main }} onClick={() => toggleAddMode(true)}>
          Add hardware
        </div>
      </div>
      <div className="hardware-list">
        {hardwareList.map((hardware) => (
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, pr: 1 }} key={hardware?.id}>
              <Box sx={{ mr: 1, flex: 1 }}>
                <Select
                  className="category-select"
                  disabled={addMode}
                  fullWidth
                  value={hardware.category}
                  onChange={(value) => onCategoryChange(hardware.id, value)}
                  options={hardwareCategories.map((item) => ({ key: item, label: item, value: item }))}
                />
              </Box>
             <Box sx={{ flex: 1, ml: 1, mr: 1 }}>
               <Select
                 id="user-select"
                 className="user-select"
                 fullWidth
                 disabled={addMode}
                 value={hardware.product}
                 onChange={(value) => onChange(hardware.id, value)}
                 options={filteredProducts.map((item) => ({ key: item, label: item, value: item }))}
               />
             </Box>
              <Box sx={{ ml: 1, mr: 1, width: 60 }}>
                <Input
                  value={hardware.amount}
                  onChange={(e) => onAmountChange(hardware.id, e.target.value)}
                  type="number"
                />
              </Box>

              <Box className="d-flex flex-center" onClick={() => onRemove(hardware.id)}>
                <CloseIcon className="pointer" color="primary" fontSize="small" />
              </Box>
          </Box>
        ))}
      </div>
      {addMode && (
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, pr: 1 }}>
            <Box sx={{ flex: 1, mr: 1 }}>
              <Select
                error={hasError}
                className="category-select"
                value={category}
                fullWidth
                onChange={(value) => {
                  setCategory(value);
                  setHasError(false);
                }}
                options={hardwareCategories.map((item) => ({ key: item, label: item, value: item }))}
              />
            </Box>
            <Box sx={{ flex: 1, ml: 1, mr: 1 }}>
              <Select
                id="user-select"
                className="user-select"
                fullWidth
                value={newHardware}
                onChange={setNewHardware}
                options={filteredProducts.map((item) => ({ key: item, label: item, value: item }))}
              />
            </Box>
            <Box sx={{ ml: 1, mr: 1, width: 60 }}>
              <Input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
              <div className="pointer m-r-md" style={{ color: theme.palette.primary.main }} onClick={handleAdd}>
                Add
              </div>
              <div className="secondary pointer" onClick={() => toggleAddMode(false)}>
                Cancel
              </div>
            </Box>
        </Box>
      )}
    </div>
  );
};

HardwareList.propTypes = {
  hardwareList: PropTypes.array,
  products: PropTypes.array,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onAmountChange: PropTypes.func,
  onChange: PropTypes.func,
  title: PropTypes.string,
};

export default HardwareList;
